module.exports = {
      id: "ic-png-usage",
      viewBox: "0 0 32 32",
      url: __webpack_public_path__ + "sprite-83ccd1.smartcharts.svg#ic-png-usage",
      toString: function () {
        return this.url;
      }
    }